import { render } from "./AlatOtp.vue?vue&type=template&id=2b825ec5&scoped=true"
import script from "./AlatOtp.vue?vue&type=script&lang=js"
export * from "./AlatOtp.vue?vue&type=script&lang=js"

import "./AlatOtp.vue?vue&type=style&index=0&id=2b825ec5&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b825ec5"]])

export default __exports__